import { useUserStore } from "../store/user"
import { getErrorMessage } from "@/utils/helper"

function apiUrl(api) {
    return process.env.VUE_APP_SERVER + 'api/' + api
}

export default {
    getRootUrl(suffix) {
        return process.env.VUE_APP_SERVER + suffix
    },
    getUrl(suffix) {
        return apiUrl(suffix)
    },
    async request(method, api, data, headers, responseType, isFormData) {
        let hs = {}

        if (!isFormData && (headers == null || typeof (headers["Content-Type"]) == "undefined" || headers["Content-Type"] == null)) {
            hs["Content-Type"] = "application/json"
        }

        if (headers) {
            for (var key in headers) {
                hs[key] = headers[key]
            }
        }

        const userStore = useUserStore()

        if (userStore.provider == 'Token') {
            const token = await userStore.getAccessToken()

            if (token) {
                hs["Authorization"] = "Bearer " + token
            }
        }

        const response = await fetch(apiUrl(api), {
            method: method,
            headers: hs,
            credentials: "include",
            redirect: 'manual',
            body: isFormData ? data : data ? JSON.stringify(data) : null
        })

        if (response.ok) {
            if (responseType == "blob") {
                return await response.blob()
            } else {
                const txt = await response.text()

                if (responseType == "text") {
                    return txt
                } else if (txt) {
                    return JSON.parse(txt)
                }
            }
        } else {
            if (response.status == 401) {
                userStore.signin()
                return null
            } else {
                const txt = await response.text()

                if (txt) {
                    if (responseType == "text") {
                        throw new Error(txt)
                    } else {
                        const err = JSON.parse(txt)
                        throw new Error(getErrorMessage(err))
                    }
                } else {
                    throw new Error('Server error!')
                }
            }
        }

        return null;
    },
    get: async function (url) {
        return await this.request("GET", url)
    },
    post: async function (url, data) {
        return await this.request("POST", url, data)
    },
    async download(url, method, data) {
        if (method == 'GET') {
            return await this.request("GET", url, null, null, "blob")
        } else {
            return await this.request(method, url, data, null, "blob")
        }
    },
    async put(url, data) {
        return await this.request("PUT", url, data)
    },
    async putUpload(url, data) {
        return await this.request("PUT", url, data, null, null, true)
    },
    async postUpload(url, data) {
        return await this.request("POST", url, data, null, null, true)
    },
    async delete(url) {
        return await this.request("DELETE", url)
    }
}